export default __webpack_public_path__ + "static/media/android_store.16781e2e.svg";